// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"styles_sidebar__VtPxY","large":"styles_large__d6cpq"};